module.exports = __webpack_public_path__ + "static/media/Customer Indentifier Fixing.d14c0106.svg";